export default __webpack_public_path__ + "static/media/project_mick.a4242ef9.jpg";